import * as React from 'react';
import styles from './index.less';
import {Tooltip} from 'antd';
import type { TooltipProps } from 'antd';

type FTooltipProps = TooltipProps & {
  title: React.ReactNode;
  children: React.ReactNode;
};

function FTooltip({children, title, placement = 'bottomLeft', arrow = {pointAtCenter: true}, ...props}: FTooltipProps) {
  return (
    <Tooltip
      title={<span className={styles.title}>{title}</span>}
      color={'#fff'}
      arrow={arrow}
      placement={placement}
      {...props}
    >
      <span style={{ display: 'inline-block' }}>{children}</span>
    </Tooltip>
  );
}

export default FTooltip;
